export default "__VITE_ASSET__22e62734__"